import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import {
  Application,
  ApplicationGroup,
  NewRole,
} from '../../shared/models/authorizationService.model';
import { SiteState } from '../../shared/models/siteState.model';
import { setUseraccess } from '../store/actions/profile.actions';
import {
  selectApplicationsForGroup,
  selectProfileType,
  selectRoles,
  selectSelectedRole,
} from '../store/selectors/profile.selectors';

@Component({
  selector: 'app-profile-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss'],
  standalone: false,
})
export class LicensesComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input()
  public applications: Application[];

  @Input()
  public applicationGroups: ApplicationGroup[];

  profileType$: Observable<string> = this.store.select(selectProfileType);
  roles$: Observable<NewRole[]> = this.store.select(selectRoles);

  public applicationsPerGroup: Map<ApplicationGroup, Application[]> = new Map<
    ApplicationGroup,
    Application[]
  >();

  constructor(private store: Store<SiteState>) {}

  ngOnInit(): void {
    this.applicationGroups.forEach((group) => {
      this.applicationsPerGroup.set(
        group,
        this.applications.filter((a) => a.applicationGroupId === group.id),
      );
    });
  }

  getSelectedRole(applicationKey: string) {
    return this.store.select(selectSelectedRole, applicationKey);
  }

  getApplications(groupId: number) {
    return this.store.select(selectApplicationsForGroup, groupId);
  }

  setUseraccess(applicationKey: string, roleKey: string) {
    return this.store.dispatch(setUseraccess({ applicationKey, roleKey }));
  }
}
